import { localStorage } from 'dibs-browser-storage';
import { VisitCountModel } from 'dibs-visit-tracking';

const STORAGE_KEY_PDP_VISITS = 'pdpVisits';
const LIMIT_PDP_STORAGE = 200;
const LIMIT_PDP_MULTIPLE_VISITS = 2;

export const MODAL_TYPE_SAME_PDP = 'samePdp';
export const MODAL_TYPE_AUTO = 'auto';

export const canShowAutoModal = () => {
    const visitCountModel = new VisitCountModel();
    return visitCountModel.get('session') === visitCountModel.get('regPromptLimit');
};

export const storePdpVisit = ({ itemId }) => {
    const pdpVisits = localStorage.getItem(STORAGE_KEY_PDP_VISITS) || [];
    const pdpIndex = pdpVisits.findIndex(pdpId => pdpId[itemId]);

    if (pdpIndex !== -1) {
        const pdp = pdpVisits.splice(pdpIndex, 1)[0]; // Removes pdp from visits array

        pdp[itemId] = pdp[itemId] + 1; // Increases visits counter
        pdpVisits.unshift(pdp); // Inserts into front
    } else {
        pdpVisits.unshift({ [itemId]: 1 }); // Inserts into front new pdp if yet it was not visited
    }

    // Removes last pdp if length exceeds limit
    if (pdpVisits.length > LIMIT_PDP_STORAGE) {
        pdpVisits.pop();
    }

    localStorage.setItem(STORAGE_KEY_PDP_VISITS, pdpVisits);
};

export const wasPdpVisitedMultipleTimes = ({ itemId }) => {
    const pdpVisits = localStorage.getItem(STORAGE_KEY_PDP_VISITS) || [];
    const pdp = pdpVisits.find(pdpId => pdpId[itemId]) || {};
    return pdp[itemId] >= LIMIT_PDP_MULTIPLE_VISITS;
};

export const getItemId = (path = '') => {
    let itemId = path.split('/');
    itemId = itemId.find(section => section.indexOf('id-') === 0) || '';
    itemId = itemId.split('-');
    itemId = itemId.length === 2 ? itemId[1] : '';
    return itemId;
};
